/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlManagedClientRequestCategories = {
    Prospect: 'Prospect',
    Customer: 'Customer',
    CoalitionPolicyholder: 'Coalition Policyholder',
    CustomerOrPolicyholder: 'Customer or Policyholder'
} as const;
export type ControlManagedClientRequestCategories = typeof ControlManagedClientRequestCategories[keyof typeof ControlManagedClientRequestCategories];


export function ControlManagedClientRequestCategoriesFromJSON(json: any): ControlManagedClientRequestCategories {
    return ControlManagedClientRequestCategoriesFromJSONTyped(json, false);
}

export function ControlManagedClientRequestCategoriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlManagedClientRequestCategories {
    return json as ControlManagedClientRequestCategories;
}

export function ControlManagedClientRequestCategoriesToJSON(value?: ControlManagedClientRequestCategories | null): any {
    return value as any;
}

